














































































































































































import Vue from "vue";
import Modal from "@/components/root/modal/Modal.vue";
import { ModalConfig } from "@/components/root/modal";
import { computed, onMounted, ref } from "@vue/composition-api";
import { state } from "./data/state";
import { getInfoType } from "@/common/state/infotypes";
import SensitivityLabel from "@/components/SensitivityLabel.vue";
import AppCheckbox from "@/components/AppCheckbox.vue";
import { SharedState } from "@/common/state";
import { InfoTypeHelper, SensitivityLevelHelper } from "@/common/models";
import { UseLoading } from "@/common/composition/loading";
import { debounce } from "@/fp";
import Spinner from "@/components/Spinner.vue";
export default Vue.extend({
  components: {
    Modal,
    SensitivityLabel,
    AppCheckbox,
    Spinner,
  },
  props: ["modalData"],
  setup(props, { emit }) {
    const config: ModalConfig = {
      title: "",
      desc: "",
      blank: true,
      width: "50rem",
      height: "55rem",
    };

    const inputEl = ref<null | HTMLInputElement>(null);

    const query_1 = ref("");
    const selected_item = ref(null);

    const { all_labels } = state;
    console.log("all_labels", all_labels.value);

    // Synthesised group shells (`fake`) have no row on the server: their
    // sensitivity is derived from their members, so the control here would move
    // and silently do nothing. The group is reachable as a card on the
    // customization board instead, where its members are settable individually.
    // Bug 24987.
    const all_labels_display = all_labels.value
      .filter((f: any) => !f.fake)
      .map((f) => {
        return {
          id: f.id,
          name: f.labelName,
          sensitivity: f.sensitivity,
          code: f.code,
          origin: f.origin,
          desc: f.description || f.desc,
          path: f.path,
          parents: ((f.path as string[]) || [])
            .map((id) => getInfoType(id).labelName)
            .join(" > "),
        };
      });

    const display_labels = computed(() => {
      const query = query_1.value.toLowerCase();
      return all_labels_display.filter(
        (f) => (f.name as string).toLowerCase().search(query) > -1
      );
    });

    const on_item_selected = (item: any) => {
      selected_item.value = JSON.parse(JSON.stringify(item));
      /* let labels_path = item.path;
      if (labels_path.length > 1) {
        labels_path = labels_path.filter((l_id) => l_id !== item.id);
      }
      emit("submit", labels_path); */
    };

    const is_selected_l0_personal = computed(() => {
      if (!selected_item.value) {
        return false;
      }
      // @ts-ignore
      return selected_item.value.path[0] === InfoTypeHelper.REGULATED_ID();
    });

    const has_custom_label_feature = computed(() =>
      SharedState.FeatureHelper.is_enabled("custom_information_type")
    );

    const can_teach = computed(
      () => has_custom_label_feature.value && !is_selected_l0_personal.value
    );

    const delete_label = () => {
      emit("submit", { action: "delete_label", label: selected_item.value });
    };

    const improve_label = () => {
      emit("submit", { action: "improve", label: selected_item.value });
    };

    const [is_updating_sensitivity, set_is_updating_sensitivity] = UseLoading(
      false
    ).as_arr();
    const update_sensitivity = debounce(250)(async (val: number) => {
      const sensitivity_int = SensitivityLevelHelper.floatToInt(val);
      set_is_updating_sensitivity(true);

      const success = await state.update_label_sensitivity(
        // @ts-ignore
        selected_item.value.id,
        sensitivity_int
      );
      set_is_updating_sensitivity(false);
      if (success) {
        // @ts-ignore
        selected_item.value.sensitivity = val;
        // @ts-ignore
        all_labels_display.find(
          // @ts-ignore
          (l) => l.id == selected_item.value!.id
        )!.sensitivity = val;
      } else {
        //
      }
    });

    onMounted(() => {
      setTimeout(() => {
        if (inputEl.value) {
          inputEl.value.focus();
        }
      }, 200);
    });

    return {
      config,
      inputEl,
      query_1,
      can_teach,
      delete_label,
      improve_label,
      selected_item,
      display_labels,
      is_updating_sensitivity,
      update_sensitivity,
      on_item_selected,
    };
  },
});
